var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["c-content-block", { "space--bottom": _vm.space }] },
    [
      _c(
        "div",
        { staticClass: "t-display--md-up" },
        [
          _vm.showTitleOnDesktop && _vm.title
            ? [
                _c("div", { staticClass: "c-content-block__titlearea" }, [
                  _c("h2", { staticClass: "c-content-block__title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
                  _vm._v(" "),
                  _vm.subtitle && !_vm.api
                    ? _c("p", { staticClass: "c-content-block__subtitle" }, [
                        _vm._v(_vm._s(_vm.subtitle))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.subtitle && _vm.api
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "c-content-block__subtitle c-content-block__subtitle--link",
                          attrs: {
                            href: _vm.mapLink + _vm.linkHref,
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.subtitle))]
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._t("content")
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-display--mobile-only" },
        [
          _c(
            "v-expand",
            { attrs: { id: _vm.id, "content-id": _vm.contentId } },
            [
              _vm.title
                ? _c("template", { slot: "title" }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("template", { slot: "content" }, [_vm._t("content")], 2)
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }